(ns common.schema.entities.graph-person
  (:require [common.schema.schema-utils :as su]
            [common.schema.entities.graph-entity :as graph-entity]))

(def schema
  (concat
   graph-entity/schema

   (su/text-simple-field
    :graph-entity/first-name
    "First name"
    {:default-field-visibility :in-use
     :authorization {:access/read :role/user
                     :access/write :role/user}})

   (su/text-simple-field
    :graph-entity/last-name
    "Last name"
    {:default-field-visibility :in-use
     :authorization {:access/read :role/user
                     :access/write :role/user}})

   (su/date-field
    :graph-entity/date-of-birth
    "Date of birth"
    {:default-field-visibility :in-use
     :authorization {:access/read :role/user
                     :access/write :role/user}})

   (su/text-simple-field
    :graph-entity/identification-number
    "Identification number"
    {:default-field-visibility :in-use
     :authorization {:access/read :role/user
                     :access/write :role/user}})

   (su/text-simple-field
    :graph-entity/country-of-residence
    "Country of residence"
    {:default-field-visibility :in-use
     :authorization {:access/read :role/user
                     :access/write :role/user}})

   (su/boolean-field
    :graph-entity/pep?
    "PEP"
    {:default-field-visibility :in-use
     :authorization {:access/read :role/user
                     :access/write :role/user}})))
